import {Button as BootStrapButton} from 'react-bootstrap';

interface Props extends React.ComponentProps<typeof BootStrapButton> {
  variant?: 'primary' | 'secondary';
  loading?: boolean;
}

function Button({variant = 'primary', ...props}: Props) {
  const className = variant === 'primary' ? 'primary-btn' : 'secondary-btn';

  return (
    <BootStrapButton
      {...props}
      loading={props.loading?.toString()}
      disabled={props.disabled || props.loading}
      className={`btn text-nowrap ${className} ${props.className}`}
      variant=""
    >
      {props.loading ? <span className="btn-loader"></span> : props.children}
    </BootStrapButton>
  );
}

export default Button;
